import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import {
    ContactContainer,
    Hero,
    ContactSection,
    ContactInfo,
    ContactForm,
} from './styles';
import { Button } from '../../components/Button';
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast";
import { BASE_API_URL_ENDPOINT } from '../../api/Api';

const RecrutementForm = () => {
    const [news, setNews] = useState([]);
    const { id } = useParams(); // Récupère l'ID depuis l'URL
    const newsId = parseInt(id, 10);
    const newsItem = news.find((item) => item.id === newsId);
    const [isLoadingNews, setIsLoadingNews] = useState(true); // ← Nouveau

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date)) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await axios.get(`${BASE_API_URL_ENDPOINT}news`);
                setNews(response.data.data);
            } catch (error) {
                console.error("Erreur de chargement des actualités :", error);
                toast.error("Erreur de chargement des offres.");
            } finally {
                setIsLoadingNews(false); // ← Important !
            }
        };

        fetchNews();
    }, []);

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        nom: '',
        postnom: '',
        prenom: '',
        email: '',
        numero: '',
        cv_name: null,
        lm_name: null,
        date_naissance: '',
        sexe: '',
        province: '',
        niveau_etude: '',
        diplome: '',
        enquetes: [],
        langues: [],
        ordre_mission: null,
    });


    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };

    const handleCheckboxChange = (e, field) => {
        const value = e.target.value;
        const isChecked = e.target.checked;

        setFormData(prev => {
            const updatedValues = isChecked
                ? [...prev[field], value]
                : prev[field].filter((item) => item !== value);
            return { ...prev, [field]: updatedValues };
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        // Vérification des champs obligatoires pour langues et enquetes
        if (formData.langues.length === 0) {
            toast.error("Veuillez sélectionner au moins une langue.");
            return;
        }

        if (formData.enquetes.length === 0) {
            toast.error("Veuillez sélectionner au moins une enquête.");
            return;
        }
        setLoading(true);

        const data = new FormData();
        data.append('news_id', newsId);
        data.append('nom', formData.nom);
        data.append('postnom', formData.postnom);
        data.append('prenom', formData.prenom);
        data.append('email', formData.email);
        data.append('numero', formData.numero);
        data.append('cv_name', formData.cv_name);
        data.append('lm_name', formData.lm_name);
        data.append('ordre_mission', formData.ordre_mission);
        data.append('status', '0');
        data.append('date_naissance', formData.date_naissance);
        data.append('sexe', formData.sexe);
        data.append('province', formData.province);
        data.append('niveau_etude', formData.niveau_etude);
        data.append('diplome', formData.diplome);
        data.append('enquetes', JSON.stringify(formData.enquetes));
        data.append('langues', JSON.stringify(formData.langues));


        try {
            const res = await axios.post(`${BASE_API_URL_ENDPOINT}process/recrutement/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (res.data.state) {
                toast.success("Candidature envoyée !");
                setFormData({
                    nom: '',
                    postnom: '',
                    prenom: '',
                    email: '',
                    numero: '',
                    cv_name: null,
                    lm_name: null,
                    ordre_mission: null,
                    date_naissance: '',
                    sexe: '',
                    province: '',
                    niveau_etude: '',
                    diplome: '',
                    enquetes: [],
                    langues: [],
                });
                document.getElementById("cv_name").value = null;
                document.getElementById("lm_name").value = null;
                document.getElementById("ordre_mission").value = null;

            } else {
                toast.error("Erreur lors de l'envoi.");
            }
        } catch (error) {
            console.error("Erreur lors de l'envoi du formulaire :", error);
            toast.error("Une erreur est survenue.");
        } finally {
            setLoading(false);
        }
    };
    if (!isLoadingNews && (!newsItem || newsItem.category !== 2)) {
        return (
            <ContactContainer>
                <Hero>
                    <h1>Ce lien n’est pas ou n’est plus valide</h1>
                    <p>Veuillez vérifier l’URL ou contacter l’administrateur du site.</p>
                </Hero>
            </ContactContainer>
        );
    }



    return (
        <ContactContainer>
            <Hero>
                <h1>Postulez maintenant</h1>
                <p>Rejoignez notre équipe et faites la différence</p>
            </Hero>

            <ContactSection className="container">
                <ContactInfo>
                    {isLoadingNews ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem' }}>
                            <Circles
                                height="80"
                                width="80"
                                color="#007BFF"
                                ariaLabel="loading"
                            />
                            <p>Chargement de l'offre...</p>
                        </div>
                    ) : newsItem ? (
                        <>
                            <h2>Recrutement</h2>
                            <h1>{newsItem.title}</h1>
                            <p>{formatDate(newsItem.date)}</p>
                            <div>
                                {newsItem.content.split('\n').map((paragraph, index) => (
                                    <p key={index}>{paragraph}</p>
                                ))}
                            </div>
                            <h2>Etapes de recrutement</h2>
                            <ul>
                                {newsItem.steps.map((step, index) => (
                                    <li key={index}>{step}</li>
                                ))}
                            </ul>
                        </>
                    ) : (
                        <p>Aucune offre trouvée .</p>
                    )}
                </ContactInfo>

                {isLoadingNews ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem' }}>
                        <Circles
                            height="80"
                            width="80"
                            color="#007BFF"
                            ariaLabel="loading"
                        />
                        <p>Chargement du formulaire...</p>
                    </div>
                ) : newsItem ? (


                    <ContactForm onSubmit={handleSubmit}>

                        <h2>Formulaire de candidature</h2>

                        <div className="form-group">
                            <label htmlFor="nom">Nom*</label>
                            <input type="text" name="nom" id="nom" value={formData.nom} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="prenom">Post-nom*</label>
                            <input type="text" name="postnom" id="postnom" value={formData.postnom} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="prenom">Prénom*</label>
                            <input type="text" name="prenom" id="prenom" value={formData.prenom} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" name="email" id="email" value={formData.email} onChange={handleChange} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="numero">Téléphone*</label>
                            <input type="number" name="numero" id="numero" value={formData.numero} onChange={handleChange} required />
                        </div>
                        {/* Date de naissance */}
                        <div className="form-group">
                            <label htmlFor="date_naissance">Date de naissance*</label>
                            <input
                                type="date"
                                name="date_naissance"
                                id="date_naissance"
                                value={formData.date_naissance}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Sexe */}
                        <div className="form-group">
                            <label>Sexe*</label>
                            <select name="sexe" value={formData.sexe} onChange={handleChange} required>
                                <option value="">-- Choisissez --</option>
                                <option value="Homme">Homme</option>
                                <option value="Femme">Femme</option>
                            </select>
                        </div>

                        {/* Province d'affectation */}
                        <div className="form-group">
                            <label>Province d’affectation*</label>
                            <select name="province" value={formData.province} onChange={handleChange} required>
                                <option value="">-- Choisissez --</option>
                                <option value="Kinshasa">Kinshasa</option>
                                <option value="Kongo-Central">Kongo-Central</option>
                                <option value="Kwango">Kwango</option>
                                <option value="Kwilu">Kwilu</option>
                                <option value="Mai-Ndombe">Mai-Ndombe</option>
                                <option value="Kasai">Kasai</option>
                                <option value="Kasai-Oriental">Kasai-Oriental</option>
                                <option value="Lomami">Lomami</option>
                                <option value="Sankuru">Sankuru</option>
                                <option value="Mongala">Mongala</option>
                                <option value="Tshuapa">Tshuapa</option>
                                <option value="Nord-Ubangi">Nord-Ubangi</option>
                                <option value="Sud-Ubangi">Sud-Ubangi</option>
                                {/* Ajoute les autres provinces ici */}
                            </select>
                        </div>

                        {/* Niveau d’étude */}
                        <div className="form-group">
                            <label>Niveau d’étude*</label>
                            <select name="niveau_etude" value={formData.niveau_etude} onChange={handleChange} required>
                                <option value="">-- Choisissez --</option>
                                <option value="Secondaire">Secondaire</option>
                                <option value="Universitaire">Universitaire</option>
                                <option value="Post-Univertaire">Post-Univertaire</option>
                            </select>
                        </div>

                        {/* Diplôme  */}
                        <div className="form-group">
                            <label>Diplôme principal*</label>
                            <select name="diplome" value={formData.diplome} onChange={handleChange} required>
                                <option value="">-- Choisissez --</option>
                                <option value="Diplôme d'état">Diplôme d'état</option>
                                <option value="Graduat">Graduat</option>
                                <option value="Licence">Licence</option>
                                <option value="Master">Master</option>
                                <option value="Doctorat">Doctorat</option>
                                <option value="Autre">Autre</option>
                            </select>
                        </div>

                        {/* Enquêtes auxquelles ils ont participé */}
                        <div className="form-group">
                            <label>Enquêtes auxquelles vous avez participé*</label>
                            <div>
                                <input type="checkbox" value="PECS 2022" onChange={e => handleCheckboxChange(e, 'enquetes')} /> PECS 2022<br />
                                <input type="checkbox" value="PECS 2023" onChange={e => handleCheckboxChange(e, 'enquetes')} /> PECS 2023<br />
                                <input type="checkbox" value="PECS 2024" onChange={e => handleCheckboxChange(e, 'enquetes')} /> PECS 2024<br />
                                <input type="checkbox" value="ECVM" onChange={e => handleCheckboxChange(e, 'enquetes')} /> ECVM <br />
                                <input type="checkbox" value="EDS" onChange={e => handleCheckboxChange(e, 'enquetes')} /> EDS<br />
                                <input type="checkbox" value="MICS" onChange={e => handleCheckboxChange(e, 'enquetes')} /> MICS<br />
                                <input type="checkbox" value="ECV" onChange={e => handleCheckboxChange(e, 'enquetes')} /> ECV <br />
                                <input type="checkbox" value="Autre" onChange={e => handleCheckboxChange(e, 'enquetes')} /> Autre
                            </div>
                        </div>

                        {/* Langues parlées */}
                        <div className="form-group">
                            <label>Langues parlées*</label>
                            <div>
                                <input type="checkbox" value="Français" onChange={e => handleCheckboxChange(e, 'langues')} /> Français<br />
                                <input type="checkbox" value="Lingala" onChange={e => handleCheckboxChange(e, 'langues')} /> Lingala<br />
                                <input type="checkbox" value="Swahili" onChange={e => handleCheckboxChange(e, 'langues')} /> Swahili <br />
                                <input type="checkbox" value="Tshiluba" onChange={e => handleCheckboxChange(e, 'langues')} /> Tshiluba<br />
                                <input type="checkbox" value="Kikongo" onChange={e => handleCheckboxChange(e, 'langues')} /> Kikongo<br />
                                <input type="checkbox" value="Autre" onChange={e => handleCheckboxChange(e, 'langues')} /> Autre
                            </div>
                        </div>



                        <div className="form-group">
                            <label htmlFor="cv_name">CV* (PDF)</label>
                            <input type="file" name="cv_name" id="cv_name" accept="application/pdf" onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="lm_name">Lettre de motivation* (PDF)</label>
                            <input type="file" name="lm_name" id="lm_name" accept="application/pdf" onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="ordre_mission">Ordre de mission (PDF)</label>
                            <input type="file" name="ordre_mission" id="ordre_mission" accept="application/pdf" onChange={handleChange} />
                        </div>

                        <Toaster position="top-center" />

                        {loading ? (
                            <Button disabled>Envoi en cours...</Button>
                        ) : (
                            <Button $primary type="submit">Envoyer la candidature</Button>
                        )}
                    </ContactForm>
                ) : (

                    <p>Aucun formulaire .</p>
                )}





            </ContactSection>
        </ContactContainer >
    );
};

export default RecrutementForm;
